import { render, staticRenderFns } from "./assistantsettingandupload.vue?vue&type=template&id=4c664304&lang=pug"
import script from "./assistantsettingandupload.vue?vue&type=script&lang=js"
export * from "./assistantsettingandupload.vue?vue&type=script&lang=js"
import style0 from "./assistantsettingandupload.vue?vue&type=style&index=0&id=4c664304&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports